import { useContext } from "react";
import useSWR from "swr";
import { environment } from "../config/environment";
import { SearchResponseModel } from "../models/SearchModels";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";

export function useSearchReceivables(searchStr: string) {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<SearchResponseModel[]>(
    searchStr
      ? `${environment.apiUrl}/api/combined-search/customer-invoice-source?name=${encodeURIComponent(searchStr)}`
      : null,
    (url) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to search receivables, please try again later", "error");
      },
    }
  );

  return {
    result: data,
    isLoading,
    isError: !!error,
  };
}
